import { IconProps } from "./types";
import React from "react";

export const ArrowIcon = ({
  className,
  fill = "currentColor",
  width = 14,
  height = 14,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    height={height}
    width={width}
    viewBox="0 0 14 14"
    className={className}
    style={style}
    fill="none"
  >
    <path
      d="M3.0625 7.32861L7 11.2661L10.9375 7.32861M7 10.7192V2.73486"
      stroke={fill}
      strokeMiterlimit="10"
      strokeLinecap="square"
    />
  </svg>
);
